import React, {useContext} from 'react';
import { List as MUIList, ListItem, ListItemAvatar, ListItemText, Avatar, ListItemSecondaryAction, IconButton, Slide } from '@material-ui/core';
import { Delete, AccountBalanceWallet } from '@material-ui/icons';
import useStyles from './Style';
import { ExpenseContext } from '../../context/context';

const List = () => {
    const classes = useStyles();
    const { deleteTransaction, transactions } = useContext(ExpenseContext);


    return (
        <MUIList dense={false} className={classes.list} >
            {transactions.map(transaction => (
                <Slide direction="down" in mountOnEnter unmountOnExit key={transaction.id}>
                    <ListItem>
                        <ListItemAvatar>
                            <Avatar className={transaction.type === "Income" ? classes.avatarIncome : classes.avatarExpense}>
                                <AccountBalanceWallet />
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText primary={transaction.category} secondary={`₹${transaction.amount} - ${transaction.date}`} />
                        <ListItemSecondaryAction>
                            <IconButton onClick={() => deleteTransaction(transaction.id)} >
                                <Delete />
                            </IconButton>
                        </ListItemSecondaryAction>

                    </ListItem>
                </Slide>
            ))}
        </MUIList>
    );
}

export default List;